import { BACKEND_URL } from 'shared/constants';
export function backendFetch(path, init) {
    var _a;
    const request = init !== null && init !== void 0 ? init : {};
    const { headers } = request;
    const headersWithVersion = Object.assign(Object.assign({}, headers), { 'x-superhuman-version': (_a = process.env.GIT_REVISION) !== null && _a !== void 0 ? _a : '' });
    return fetch(`${BACKEND_URL}${path}`, Object.assign(Object.assign({}, request), { headers: headersWithVersion }));
}
